import React, { useEffect } from 'react';
import '../styles/CaseStudyDetail.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';

const CaseStudy3 = () => {

    useEffect(() => {
        document.title = "Unified Data for Smarter Insurance Decisions | Datamatics Consulting";
    }, []);
    return (
        <div className="cs-page">

            {/* Hero */}
            <section className="cs-hero">
                <div className="cs-hero-overlay">
                    <span className="cs-sector-badge">Insurance Sector</span>
                    <h1>Unified Data for Smarter Insurance Decisions</h1>
                    <p>By consolidating silos into a single data platform, a top insurer improved reporting speed, reduced costs, and achieved greater decision accuracy.</p>
                </div>
            </section>

            {/* Body */}
            <section className="cs-body container">
                <div className="cs-section">
                    <div className="cs-label">Challenge</div>
                    <div className="cs-content">
                        <p>A top insurer was struggling with disconnected data silos, inconsistent reporting, and limited visibility across its core operations. Leaders could not see a complete picture of customers, risks, or performance. This lack of transparency slowed strategic planning, created inefficiencies, and drove up costs — all while competitors were moving faster with modern analytics.</p>
                    </div>
                </div>
                <div className="cs-divider" />
                <div className="cs-section">
                    <div className="cs-label">Our Approach & Solution</div>
                    <div className="cs-content">
                        <p>The Datamatics team worked closely with the insurer's leadership to map data pain points across finance, underwriting, and claims. The goal was to unify siloed data into a consistent foundation and make insights accessible to business users without technical bottlenecks.</p>
                        <p>We implemented an <strong>Enterprise Data Platform</strong> on the <strong>Microsoft technology stack</strong>, consolidating more than <strong>1,200 critical data attributes</strong> into a single governed environment. On top of this foundation, we designed and rolled out <strong>60+ interactive dashboards</strong>, giving executives and managers a unified view of operations — from risk and compliance to customer experience.</p>
                    </div>
                </div>
            </section>

            {/* Results */}
            <section className="cs-results">
                <h2>Results</h2>
                <div className="cs-results-grid">
                    <div className="cs-stat">
                        <span className="cs-stat-number">1200+</span>
                        <p>Attributes unified, enabling a single source of truth.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">40%</span>
                        <p>Faster reporting, increasing agility and responsiveness.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">20%</span>
                        <p>Reduction in operating costs through streamlined reporting.</p>
                    </div>
                    <div className="cs-stat">
                        <span className="cs-stat-number">35%</span>
                        <p>Sharper, more accurate decisions across underwriting, claims, and compliance.</p>
                    </div>
                </div>
            </section>

            {/* Other Case Studies */}
            <section className="cs-related container">
                <div className="cs-related-header">
                    <div className="purple-line-cs"></div>
                    <span className="cs-related-label">Case Studies</span>
                </div>
                <div className="cs-cards-grid">
                    {[
                        { title: "Building a Trusted Data Foundation for Financial Services", image: images.newcase1, to: "/case-studies/financial-services" },
                        { title: "Modernizing Compliance & Reporting with Data at Scale", image: images.newcase2, to: "/case-studies/banking" },
                        { title: "A Single Customer View for Better Airline Experiences", image: images.newcase4, to: "/case-studies/airline" },
                    ].map((s, i) => (
                        <div key={i} className="cs-card" onClick={() => handleLinkClick(s.to)} style={{ cursor: 'pointer' }}>
                            <div className="cs-card-img-wrap">
                                <img src={s.image} alt={s.title} />
                            </div>
                            <h3>{s.title}</h3>
                            <a href={s.to} className="cs-read-more" onClick={(e) => { e.preventDefault(); handleLinkClick(s.to); }}>Read More →</a>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default CaseStudy3;